// extracted by mini-css-extract-plugin
module.exports = {"L":"1440","M":"1024","S":"768","XS":"576"};